import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import styles from './OpSelect.module.css';
import './stylesheets/op2mise-select.css';
import clsx from 'clsx';

export const OpSelect = (props) => {
  const {
    // Custom Props
    label,
    errorMessage,
    showLabelAsterisk,
    labelPosition = 'top',
    containerClass = '',

    // SyncFusion Dropdown Props
    id,
    cssClass,
    dataSource,
    fields,
    valueTemplate,
    ...rest
  } = props;

  const selectContainerClass = `${styles.opSelectContainer} ${
    labelPosition === 'left' ? styles.leftLabel : styles.topLabel
  } ${containerClass ?? ''}`.trim();

  return (
    <div className={`${label ? selectContainerClass : ''}`}>
      {label && (
        <label className={styles.fieldLabel}>
          {label}
          {showLabelAsterisk && <span>*</span>}
        </label>
      )}
      <DropDownListComponent
        cssClass={clsx(
          'op-select',
          cssClass,
          !rest.enabled ? 'op-select-disabled' : ''
        )}
        dataSource={dataSource}
        fields={fields}
        id={id}
        itemTemplate={(item) => (
          <div title={item.name}>
            <div className="text-truncate">{item.name}</div>
          </div>
        )}
        {...rest}
      />
    </div>
  );
};
